import { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { MdPersonPin } from "react-icons/md";
import { FiEdit, FiCheck, FiTrash2 } from "react-icons/fi";
import { MuiTelInput } from "mui-tel-input";
import { useTranslation } from 'react-i18next';
import { TextField } from "@mui/material";
import Swal from "sweetalert2";

const ClientContactInfoCard = ({ contactoInfo, onSave }) => {
    const { t } = useTranslation();
    const [editMode, setEditMode] = useState({ celular: false, alias: false });
    const [formData, setFormData] = useState({
        countrycode: contactoInfo?.countrycode || "",
        celular: contactoInfo?.celular || "",
        alias: contactoInfo?.alias || "",
    });

    const handleChange = (field, value) => {
        setFormData({ ...formData, [field]: value });
    };

    const handleSave = (field) => {
        setEditMode({ ...editMode, [field]: false });
        onSave && onSave(formData);
    };

    const handleClear = () => {
        alertaConfirmar('ELIMINAR CONTACTO', 'estás seguro que quieres eliminar el contacto de este pedido?.', 'warning', (res_alert) => {
            if (res_alert === true) {
                const emptyData = { countrycode: '', celular: '', alias: '' };
                setFormData(emptyData);
                onSave && onSave(emptyData);
            }
        })
    };


    const alertaConfirmar = (titulo, texto, icon, callback) => {
        Swal.fire({
            title: titulo,
            html: texto,
            icon: icon,
            showCancelButton: true,
            confirmButtonText: 'Si',
            denyButtonText: 'No',
            cancelButtonText: 'Cancelar',

            confirmButtonColor: '#2C3E50',
            cancelButtonColor: '#CB4335'
        }).then((result) => {
            if (result.isConfirmed) {
                callback(result.isConfirmed)
            }
        })
    }

    return (
        <div className="mt-5 relative text-brand-900 dark:text-brand-200 bg-white dark:bg-brand-900 shadow-lg shadow-brand-300 dark:shadow-black rounded-lg space-y-4">
            <label className="block text-lg font-semibold mb-2 pl-5 pr-5 pt-5">{t('infoclient')}</label>

            {/* Botón Eliminar elegante */}
            <button
                className="absolute top-2 right-3 bg-red-500 hover:bg-red-600 text-white p-2 rounded-full shadow-md transition duration-300"
                onClick={handleClear}
                title={t('delete')}
            >
                <FiTrash2 size={20} />
            </button>
            <div className="w-full mt-4 px-5 py-3 space-y-4">
                {/* Bandera */}
                <div className="flex items-center">
                    <img
                        className="object-cover h-6 w-8 rounded-sm shadow"
                        alt="Country flag"
                        src={`/images/flags/4x3/${formData?.countrycode || 'pe'}.svg`}
                    />
                </div>

                {/* Celular y Alias en grid responsivo */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                    {/* Celular */}
                    <div className="flex items-center justify-between bg-white dark:bg-black rounded-lg p-3">
                        <div className="flex items-center text-sm gap-2 w-full">
                            <FaWhatsapp size={20} className="text-green-500" />
                            {editMode.celular ? (
                                <MuiTelInput
                                    label={t('phonenumber')}
                                    variant="filled"
                                    autoFocus
                                    defaultCountry="PE"
                                    value={formData.celular}
                                    onChange={(newValue, info) =>
                                        setFormData({ ...formData, countrycode: info.countryCode, celular: newValue })
                                    }
                                    InputLabelProps={{
                                        style: {
                                            color: '#e9ecef', fontSize: 17, paddingBottom: 5,
                                            fontFamily: "Jost, sans-serif"
                                        }, shrink: true
                                    }}
                                    inputProps={{
                                        className: "text-brand-900 dark:text-brand-200 bg-transparent border-b border-brand-500 outline-none w-full"
                                    }}
                                    className="bg-brand-100 dark:bg-brand-900 rounded-lg w-full"
                                />
                            ) : (
                                <span className="truncate">{formData.celular}</span>
                            )}
                        </div>
                        <button
                            className={`ml-2 p-2 rounded-full transition duration-300 ${editMode.celular ? 'bg-green-500 hover:bg-green-600 text-white' : 'bg-yellow-500 hover:bg-yellow-400 text-white'
                                }`}
                            onClick={() =>
                                editMode.celular ? handleSave("celular") : setEditMode({ ...editMode, celular: true })
                            }
                        >
                            {editMode.celular ? <FiCheck size={20} /> : <FiEdit size={20} />}
                        </button>
                    </div>

                    {/* Alias */}
                    <div className="flex items-center justify-between bg-white dark:bg-black rounded-lg p-3">
                        <div className="flex items-center text-sm gap-2 w-full">
                            <MdPersonPin size={20} className="text-blue-500" />
                            {editMode.alias ? (
                                <TextField
                                    name="alias"
                                    variant="filled"
                                    autoFocus
                                    value={formData.alias}
                                    onChange={(e) => handleChange("alias", e.target.value)}
                                    label={t('alias')}
                                    id="outlined-basic"
                                    className="bg-brand-100 dark:bg-brand-900 rounded-lg w-full"
                                    sx={{ width: '100%' }}
                                    style={{
                                        marginTop: 10, marginBottom: 10,
                                        fontFamily: "Jost, sans-serif", fontSize: 16, color: '#c2c2c2'
                                    }}
                                    inputProps={{
                                        maxLength: 20,
                                        className: "text-brand-900 dark:text-brand-200"
                                    }}
                                    InputLabelProps={{
                                        className: "text-brand-900 dark:text-brand-200",
                                        style: { fontSize: 17, paddingBottom: 5, fontFamily: "Jost, sans-serif" },
                                        shrink: true
                                    }}
                                    type="text"
                                />
                            ) : (
                                <span className="truncate">{formData.alias}</span>
                            )}
                        </div>
                        <button
                            className={`ml-2 p-2 rounded-full transition duration-300 ${editMode.alias ? 'bg-green-500 hover:bg-green-600 text-white' : 'bg-yellow-500 hover:bg-yellow-400 text-white'
                                }`}
                            onClick={() =>
                                editMode.alias ? handleSave("alias") : setEditMode({ ...editMode, alias: true })
                            }
                        >
                            {editMode.alias ? <FiCheck size={20} /> : <FiEdit size={20} />}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClientContactInfoCard;
